import { load } from '@/router/routes/index';

export default [
    {
        path: 'proposals',
        name: 'proposal.index',
        component: load('proposal/ProposalIndex'),
        meta: { auth: true },
    },
    {
        path: 'proposals/create',
        name: 'proposal.create',
        component: load('proposal/ProposalCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'proposals/:proposalId',
        component: load('proposal/ProposalDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('proposal/ProposalShow'),
                meta: { auth: true },
                children: [
                    // {
                    //     path: '',
                    //     name: 'proposal.show',
                    //     component: load('proposal/ProposalShowOverview'),
                    //     meta: { auth: true },
                    // },
                    {
                        path: '', //'proposal-rows',
                        name: 'proposal.show', //'proposal.show.proposal-rows',
                        component: load('proposal/ProposalRowsShow'),
                        meta: { auth: true },
                    }
                ],
            },
            {
                path: 'edit',
                name: 'proposal.edit',
                component: load('proposal/ProposalEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
            {
                path: 'duplicate',
                name: 'proposal.duplicate',
                component: load('proposal/ProposalDuplicate'),
                meta: { auth: true, forceCollapsedMenu: true },
            }
        ],
    },
    {
        path: 'proposals/:proposalId/history',
        name: 'proposal.history',
        component: load('proposal/ProposalHistory'),
        meta: { auth: true },
    },
    {
        path: 'samples',
        name: 'sample.index',
        component: load('proposal/SampleIndex'),
        meta: { auth: true },
    },
    {
        path: 'samples/create',
        name: 'sample.create',
        component: load('proposal/SampleCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'samples/:sampleId',
        component: load('proposal/SampleDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('proposal/SampleShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'sample.show',
                        component: load('proposal/SampleShowOverview'),
                        meta: { auth: true },
                    }
                ],
            },
            {
                path: 'edit',
                name: 'sample.edit',
                component: load('proposal/SampleEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
            {
                path: 'duplicate',
                name: 'sample.duplicate',
                component: load('proposal/SampleDuplicate'),
                meta: { auth: true, forceCollapsedMenu: true },
            }
        ],
    },
    
];
